import { Link, useLocation } from "react-router-dom";

import PhoneIcon from "../../assets/Phone.png";
import { buildWaitlistHref } from "../../utils/waitlistContact";

export const TalkToUs = () => {
  const location = useLocation();
  const waitlistHref = buildWaitlistHref(location.search);

  return (
    <div className="bg-primary-subtle py-24">
      <div className="mx-auto w-11/12 px-4 sm:w-3/4 sm:px-6 lg:px-8">
        <div className="transform overflow-hidden rounded-2xl bg-card shadow-xl transition-all duration-300 hover:scale-[1.02]">
          <div className="flex flex-col items-center justify-between gap-8 px-6 py-12 text-center md:flex-row md:gap-6 md:p-12 md:text-left">
            {/* Column 1: Icon and Text */}
            <div className="flex flex-col items-center gap-6 md:flex-row">
              <div className="flex-shrink-0">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-card shadow-sm">
                  <img src={PhoneIcon} alt="Phone" className="h-10 w-10" />
                </div>
              </div>
              <div>
                <h2 className="mb-4 text-3xl font-bold text-foreground sm:text-4xl">Talk To Us</h2>
                <p className="text-lg text-muted-foreground">
                  Whether you're ready to schedule your first session or just have questions, we'd
                  love to hear from you.
                </p>
              </div>
            </div>

            {/* Column 2: Button */}
            <div className="w-full flex-shrink-0 md:w-auto">
              <Link
                to={waitlistHref}
                className="inline-flex w-full transform items-center justify-center rounded-xl border border-transparent bg-primary px-8 py-4 text-lg font-medium text-white transition-all hover:-translate-y-0.5 hover:bg-primary-hover hover:shadow-lg md:w-auto"
                aria-label="Schedule a Paribus demo from the Talk To Us section"
              >
                Schedule a demo
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
